import fp from 'lodash/fp'
import { toValidator, toValidatorWithArgs } from 'egoist-js'

export const MATCH_PROP_KEY = 'custom.match.prop'
export const VALID_KEY = 'custom.valid'
export const NOT_MATCH_SELECTED_TEAM_KEY = 'custom.notMatchSelectedTeam.prop'
export const AMOUNT_MORE_THAN_MAXIMUM = 'amount.more.than.maximum.prop'
export const AMOUNT_MORE_THAN_MAXIMUM_BET = 'amount.more.than.maximum.bet.prop'
export const AMOUNT_MORE_THAN_MIN_BET = 'amount.more.than.min.bet.prop'

export const matchProp = toValidatorWithArgs(
  MATCH_PROP_KEY,
  (propToCheck, value, { context }) => {
    let propName = propToCheck

    if (fp.isObject(propToCheck)) {
      propName = propToCheck.key
    }

    const propValue = fp.get(`current.${propName}`, context)
    return value === propValue
  }
)

export const valid = toValidator(VALID_KEY, () => true)
